import { createContext } from 'react'

export interface FormikContextProps {
  formik: any
}

export const FormikContext = createContext<FormikContextProps | undefined>(
  undefined
)
